<template>
  <div class="layout-box">
    <el-container>
      <el-aside v-if="isShow">
        <div class="logo">
          <img :src="menuLogo" alt @click="jumpHome" />
        </div>
        <el-menu router text-color="#999" v-if="$store.state.MenuList.length" :default-active="$route.fullPath.split('?')[0]" :collapse="true">
          <menu-tree :menuList="menuList" />
        </el-menu>
      </el-aside>
      <el-main>
        <el-header v-if="isShow">
          <div class="header-box">
            <div class="roles">
              <template v-if="availableRoles.length">
                <span>账号权限：</span>
                <el-radio-group v-model="currentRoleId" @input="swichRoleHandler">
                  <el-radio :label="item.AuthorizationId" v-for="item in availableRoles" :key="item.AuthorizationId">
                    {{ item.RoleCn }}
                  </el-radio>
                </el-radio-group>
              </template>
            </div>
            <div class="head-item">
              <div class="toggle-system" v-show="manualFiles" @click="viewManualFiles">
                <el-link type="primary">《入职培训手册》</el-link>
              </div>
              <el-divider direction="vertical" v-if="manualFiles && !$ENV.DOCUMENT_TITLE.includes('汇丰') && !$ENV.DOCUMENT_TITLE.includes('中智信')"></el-divider>
              <div class="toggle-system" @click="backOldSystem" v-if="userInfo.Role != 'BXTZH' && $ENV.ISSHOWOLDVERSION">
                <i class="el-icon-shuangmoshiqiehuan"></i>
                <span>切换旧版</span>
              </div>
              <el-dropdown trigger="click" @command="handleCommand">
                <div class="el-dropdown-link">
                  <el-avatar src="/static/picture/avatar.png"></el-avatar>
                  {{ userInfo.UserName }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="BindWeChat" v-if="isBindWeChat">绑定微信</el-dropdown-item>
                  <el-dropdown-item command="UpdatePassWord">修改密码</el-dropdown-item>
                  <el-dropdown-item command="ToggleIdentities" v-if="!userInfo.UserLoginId">切换身份</el-dropdown-item>
                  <!-- <el-dropdown-item command='Results'>业绩</el-dropdown-item> -->
                  <el-dropdown-item command="LoginOut">注销</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div class="refresh" v-if="isShowRefreshCache || userInfo.UserName === 'Admin'">
                <el-tooltip content="刷新缓存" placement="bottom" effect="light">
                  <i class="el-icon-refresh-right loadRefresh" :class="{ pausedAnimation: !isLoadRefresh }" @click="refreshCache"></i>
                </el-tooltip>
              </div>
            </div>
          </div>
        </el-header>
        <el-container class="container" :style="editStyle">
          <el-tabs type="card" class="tab-layout" closable v-model="currTab" @tab-remove="removeTab" @tab-click="clickTab" v-if="tabs.length && isShow">
            <el-tab-pane v-for="tabItem in tabs" :label="tabItem.meta.title" :name="tabItem.path" :key="tabItem.path" />
          </el-tabs>
          <!-- :include="keepAliveCache" -->
          <keep-alive>
            <router-view :key="$route.fullPath" />
          </keep-alive>
        </el-container>
        <el-footer class="footer">©{{ $ENV.COPYRIGHT }} 版本: {{ $ENV.VERSION }}</el-footer>
      </el-main>
    </el-container>
    <!-- 切换身份 -->
    <toggle-identity-dialog :isShow="ToggleIdentityShow" @cancel="ToggleIdentityShow = false" />
    <!-- 绑定微信 -->
    <bind-weChat-dialog :isShow="BindWeChatShow" @cancel="BindWeChatShow = false" v-if="BindWeChatShow" />
    <!-- 修改密码 -->
    <update-passWord-dialog :isShow="UpdatePassWordShow" @cancel="UpdatePassWordShow = false" />
  </div>
</template>
<script>
import MenuTree from '@/components/menuTree.vue';
import { LoginOut, RefreshCache, getAuthorizationList, switchAuthorizationList, GetUserAllSettings, getManualFiles } from '../http/api';
import { getActionPermit } from '../http/dictionary';
import ToggleIdentityDialog from './statusList/index.vue';
import BindWeChatDialog from './bindWeChat/index.vue';
import UpdatePassWordDialog from './updatePassWord/index.vue';
import { resetRouter } from '../router';
var that;
export default {
  name: 'layout',
  components: {
    MenuTree,
    ToggleIdentityDialog,
    BindWeChatDialog,
    UpdatePassWordDialog,
  },
  data() {
    return {
      currTab: '',
      availableRoles: [],
      currentRoleId: '',
      manualFiles: '',
      isShowRefreshCache: false,
      userInfo: JSON.parse(localStorage.userInfo || '{}'),
      ToggleIdentityShow: false,
      BindWeChatShow: false,
      UpdatePassWordShow: false,
      isLoadRefresh: false,
      keepAliveCache: '',
      isBindWeChat: this.$ENV.BIND_WECHAT,
      menuLogo: this.$ENV.MENU_LOGO,
      isShow: true, // 是否展示
    };
  },
  watch: {
    $route: {
      handler(to, from) {
        // 判断数据可视化是否展示menu,el-tabs,el-header
        this.isShow = true;
        if (to.path.startsWith('/BI/')) {
          this.isShow = false;
        }
        this.currTab = to.fullPath.split('?')[0];
      },
      immediate: true,
    },
    '$store.state.Tabs': {
      handler(val, oldVal) {
        /* 注：此处获取的name来源是子系统传递，如果与实际组件name不一致将无法实现缓存 */
        let nameList = val.map((k) => k.name);
        this.keepAliveCache = nameList;
      },
      deep: true,
    },
  },
  computed: {
    menuList() {
      let toRoute = this.$route;
      let pathArr = toRoute.fullPath.split('/');
      let item = this.$store.state.MenuList.find((val) => val.Url == pathArr[1]);
      return item && 'children' in item ? item.children : [];
    },
    tabs() {
      return this.$store.state.Tabs;
    },
    editStyle() {
      // 动态修改el-main的背景色
      if (this.isShow) {
        // 如果 isShow 为 true，设置背景色为 #f4f5f9
        return {
          background: '#f4f5f9',
          padding: '16px 16px 0 16px',
        };
      } else {
        // 如果 isShow 为 false，设置渐变背景色
        return {
          // background:
          // "linear-gradient(90deg, #c3dbf7 0%,#dde7f8 60%, #ecf0f8 100%)",
          background: `url(/static/echartsPic/Background.png) no-repeat `,
          backgroundSize: 'cover',
          padding: '16px',
        };
      }
    },
  },
  created() {
    that = this;
    this.getAuthorization();
    this.getManualFiles();
  },
  mounted() {
    // 子系统关闭菜单栏监听
    window.addEventListener('ColseTabs', function (e) {
      if (that.tabs.length == 1) return;
      that.removeTabDispose(e.detail.targetName);
    });
  },
  methods: {
    // 获取授权列表
    getAuthorization() {
      getAuthorizationList().then((res) => {
        this.availableRoles = res;
        let temp = res.find((item) => !!item.Selected);
        this.currentRoleId = temp ? temp.AuthorizationId : '';
      });
    },
    // 获取入职手册
    getManualFiles() {
      getManualFiles().then((res) => {
        this.manualFiles = res && res[0];
      });
    },
    // 切换授权角色
    swichRoleHandler() {
      this.$confirm('确定要切换账号权限吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
        customClass: 'custom-dialog-style',
      })
        .then((_) => {
          switchAuthorizationList(this.currentRoleId)
            .then((res) => {
              GetUserAllSettings().then((column) => {
                localStorage.setItem('columnArr', JSON.stringify(column));
                localStorage.setItem('userInfo', JSON.stringify(res));
                this.$router.push('/layout/home');
                location.reload();
              });
            })
            .catch(this.getAuthorization);
        })
        .catch(this.getAuthorization);
    },
    // 查看入职手册
    viewManualFiles() {
      let pdf = encodeURIComponent(`${window.BASE_API}/Common.FileStore/GetFile/BasicData?logicID=${this.manualFiles}`);
      window.open('/static/pdf/web/viewer.html?file=' + pdf, 'PDF');
    },
    // 关闭菜单栏拦截
    colseMenuIntercept(targetName, cb) {
      window.dispatchEvent(
        new CustomEvent('ColseMenuIntercept', {
          detail: {
            targetName,
            cb,
          },
        })
      );
    },
    removeTab(targetName) {
      if (this.tabs.length == 1) return; // 只剩一个无法删除
      let next = true;
      this.colseMenuIntercept(targetName, (isNext) => (next = isNext));
      if (!next) return;
      this.removeTabDispose(targetName);
    },
    // 移除菜单栏处理
    removeTabDispose(targetName) {
      let index = this.tabs.findIndex((v) => v.path == targetName);
      if (targetName == this.$route.fullPath.split('?')[0]) {
        // 删除当前，先执行跳转，再进行删除，否则判断不准确
        let nextTab = this.tabs[index + 1] || this.tabs[index - 1];
        this.$router.push(nextTab);
      }
      this.$store.commit('updateTabs', { to: this.tabs[index], type: 'del' });
    },
    clickTab(tab) {
      if (this.$route.fullPath.split('?')[0] == tab.name) return;
      let nextPath = this.tabs.find((v) => v.path == tab.name);
      this.$router.push(nextPath.fullPath);
    },
    jumpHome() {
      this.$router.push('/layout/home');
    },
    handleCommand(command) {
      switch (command) {
        case 'BindWeChat': // 绑定微信
          this.BindWeChatShow = true;
          break;
        case 'UpdatePassWord': // 修改密码
          this.UpdatePassWordShow = true;
          break;
        case 'ToggleIdentities': // 切换身份
          this.ToggleIdentityShow = true;
          break;
        case 'Results': // 业绩
          break;
        case 'LoginOut': // 注销
          this.loginOutEvent();
          break;

        default:
          break;
      }
    },
    backOldSystem() {
      let BASE_API = '';
      // 兼容ie
      if (!window.location.origin) {
        BASE_API = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
      } else {
        BASE_API = window.location.origin;
      }
      window.location.href = `${BASE_API}/old`;
    },
    loginOutEvent() {
      LoginOut().then(() => {
        localStorage.clear();
        sessionStorage.clear();
        this.$store.state.MenuList = [];
        this.$store.state.AllRoutes = [];
        this.$store.state.AllPermissionUI = [];
        resetRouter(); // 清除已注册路由
        this.$router.push('/login');
        location.reload();
      });
    },
    refreshCache() {
      if (this.isLoadRefresh) return;
      this.isLoadRefresh = true;
      RefreshCache().then((res) => {
        this.$message.success('已清除缓存!');
        this.isLoadRefresh = false;
      });
    },
    getActionPermitList() {
      const actionArr = ['Common.ServerCommon.RefreshCache'];
      getActionPermit(actionArr).then((res) => {
        this.isShowRefreshCache = res['Common.ServerCommon.RefreshCache'];
      });
    },
  },
};
</script>
<style scoped lang="less">
@import '../style/layout.less';
</style>
